import { request } from '@/axios/request';
import { Message } from 'element-ui';
import { createHumanRequest } from '@/utils/humanRequest.mjs';
import { challenge, captureVerificationReset } from '@/utils/turnstile';
import router from '@/router';

const prefix = "/user"

const humanRequest = createHumanRequest({
    captureReset: captureVerificationReset,
    context: () => window.location.hash,
    subscribeNavigation: listener => router.afterEach(listener),
    config: () => request(prefix + '/human_config', 'get', undefined, 15000).then(res => res.result),
    challenge: (sitekey, action) => challenge(sitekey, action),
    send: (url, data) => request(url, 'POST', data, 30000),
})
const guarded = (url, action, data, beforeSend) => humanRequest(url, action, data, beforeSend).catch(error => {
    // Backend envelope errors are already shown by the existing interceptor.
    if (error instanceof Error && !error.isAxiosError) Message.error(error.message)
    // Do not let page-level console logging expose Axios request credentials
    // or the single-use token in error.config / response.config.
    throw new Error(error?.response?.data?.message || error?.data?.message || error?.message || '请求失败，请稍后重试')
})

let user = {
    verificationCode : (data) => request(prefix +'/ems/send','POST',data, 30000),
    registerAccount : (data, beforeSend) => guarded(prefix +'/register', 'signup', data, beforeSend),
    registerAccountStatus : (id) => request(prefix +'/register_status?id='+id,'GET', undefined, 10000),
    resetPwdAccount : (data) => request(prefix +'/resetpwd','POST',data),
    login : (data) => guarded(prefix +'/login', 'login', data),
    loginAddr: (data) => request(prefix +'/shop_login','POST',data),
}
export default user
